import { GENDER_RECORD } from "../../../../../constants";
import { formatDate } from "../../../../../utils/date-time-utility";
import { getAddressFormat } from "../../../../../utils/utils";

interface ReferralTemplateProps {
  data: any;
}

const cardBox: React.CSSProperties = {
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  padding: "12px",
  backgroundColor: "#fff",
};

const cardTitle: React.CSSProperties = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#111827",
  margin: "0 0 8px 0",
};

const rowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "100px 10px 1fr",
  gap: "4px",
  fontSize: "12px",
  color: "#1f2937",
  marginBottom: "4px",
  alignItems: "start",
};

const labelStyle: React.CSSProperties = {
  color: "#6b7280",
};

const Row = ({ label, value }: { label: string; value: string }) => (
  <div style={rowStyle}>
    <span style={labelStyle}>{label}</span>
    <span style={labelStyle}>:</span>
    <span style={{ wordBreak: "break-word" }}>{value || "-"}</span>
  </div>
);

const ReferralTemplate = ({ data }: ReferralTemplateProps) => {
  const fromSpeciality = data?.referralFromSpecialities
    ? Object.values(data.referralFromSpecialities).join(", ")
    : "-";

  const toSpeciality = data?.referralToSpecialities
    ? Object.values(data.referralToSpecialities).join(", ")
    : "-";

  return (
    <div
      style={{
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
        padding: "16px",
        color: "#111827",
      }}
    >
      <div style={{ marginBottom: "16px" }}>
        <h2
          style={{
            fontSize: "18px",
            fontWeight: 600,
            margin: 0,
            color: "#111827",
          }}
        >
          Referral Summary
        </h2>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <div style={cardBox}>
          <p style={cardTitle}>Patient</p>
          <Row label="Name" value={data?.patientName || "-"} />
          <Row
            label="DOB"
            value={(data?.patientDob && formatDate(data.patientDob)) || "-"}
          />
          <Row
            label="Gender"
            value={
              data?.patientGender ? GENDER_RECORD[data.patientGender] : "-"
            }
          />
          <Row
            label="Address"
            value={getAddressFormat(data?.patientAddress) || "-"}
          />
        </div>

        <div style={cardBox}>
          <p style={cardTitle}>Referral From</p>
          <Row label="Name" value={data?.referralFromName || "-"} />
          <Row label="Speciality" value={fromSpeciality} />
          <Row
            label="Address"
            value={getAddressFormat(data?.referralFromAddress) || "-"}
          />
          <Row label="Phone" value={data?.referralFromPhone || "-"} />
          <Row label="Fax" value={data?.referralFromFax || "-"} />
        </div>

        <div style={cardBox}>
          <p style={cardTitle}>Referral To</p>
          <Row label="Name" value={data?.referralToName || "-"} />
          <Row label="Speciality" value={toSpeciality} />
          <Row
            label="Address"
            value={getAddressFormat(data?.referralToAddress) || "-"}
          />
          <Row label="Phone" value={data?.referralToPhone || "-"} />
          <Row label="Fax" value={data?.referralToFax || "-"} />
        </div>
      </div>

      <div style={{ ...cardBox, marginBottom: "12px" }}>
        <p style={cardTitle}>Referral Date</p>
        <Row
          label="Date"
          value={(data?.referralDate && formatDate(data.referralDate)) || "-"}
        />
      </div>

      <div style={{ ...cardBox, marginBottom: "12px" }}>
        <p style={cardTitle}>Referral Note</p>
        <p style={{ fontSize: "12px", margin: 0, whiteSpace: "pre-wrap" }}>
          {data?.referralNote || "-"}
        </p>
      </div>

      <div style={cardBox}>
        <p style={cardTitle}>Attachments</p>
        {data?.referralDocumentName ? (
          <p style={{ fontSize: "12px", margin: 0 }}>
            1. {data.referralDocumentName}
          </p>
        ) : (
          <p style={{ fontSize: "12px", margin: 0 }}>-</p>
        )}
      </div>
    </div>
  );
};

export default ReferralTemplate;
